import {
  trigger,
  state,
  style,
  transition,
  animate,
  query,
  stagger
} from '@angular/animations';

export const TestimonialsExpand = trigger('TestimonialsExpand', [
  state('default', style({height: '263px'})),
  state('more', style({height: '700px'})),
  state('all', style({height: '1000px'})),
  transition('default => more', animate('.3s ease-in-out')),
  transition('more => all', animate('.3s ease-in-out')),
  transition('all => default', animate('.3s ease-in-out'))
]);

// Default

export const FadeIn = trigger('FadeIn', [
  state('*', style({opacity: 1})),
  state('void', style({opacity: 0})),
  transition('void => *', [
    style({opacity: 0}),
    animate('.3s ease-out', style({opacity: 1}))
  ]),
  transition('* => void', [
    style({opacity: 1}),
    animate('.3s ease-out', style({opacity: 0}))
  ])
]);



// WEBPACK FOOTER //
// ./src/app/_services/animations.ts